import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import { getCleanPhoneNumber } from "@b2bportal/core-utilities";
import type { Reservation } from "@b2bportal/lodging-api";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Icon } from "@tenant/ui";
import clsx from "clsx";
import styles from "./PropertyDetails.module.scss";
import { usePropertyDetails } from "./usePropertyDetails";

interface PropertyDetailsProps {
  className?: string;
  reservation: Reservation;
}

export const PropertyDetails = ({
  reservation,
  className,
}: PropertyDetailsProps) => {
  const { t } = useI18nContext();
  const [block, cn] = useModuleBEM(styles, "PropertyDetails");
  const data = usePropertyDetails(reservation);

  if (data == null) return null;

  return (
    <div className={clsx(block, className)}>
      <h3 className={cn("title")}>{t("hotelTrips.propertyDetails")}</h3>

      {data.address !== "" && (
        <div className={cn("section")}>
          <div className={cn("field")}>
            <span className={cn("label")}>{t("hotelTrips.address")}</span>
            <a
              className={clsx(cn("value"), cn("link"))}
              href={data.mapsUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              {data.address}
            </a>
          </div>
        </div>
      )}

      {data.shopUrl !== "" && (
        <div className={cn("section")}>
          <a
            className={cn("view-listing")}
            href={data.shopUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("hotelTrips.viewStayListing")}
            <Icon iconName={IconNameEnum.externalLink} />
          </a>
        </div>
      )}

      {data.phone !== "" && (
        <div className={cn("section")}>
          <div className={cn("field")}>
            <span className={cn("label")}>
              {t("hotelTrips.contactProperty")}
            </span>
            <a
              className={clsx(cn("value"), cn("link"))}
              href={`tel:${getCleanPhoneNumber(data.phone)}`}
            >
              {data.phone}
            </a>
          </div>
        </div>
      )}
    </div>
  );
};
